<template>
    <div>
        <p v-if="sheet.status == 'approved'" class="approved"><strong><i class="fa fa-check"></i> Approved</strong></p>
        <p v-if="sheet.status == 'disputed'" class="disputed"><strong><i class="fa fa-times"></i> Disputed</strong></p>
        <p v-if="sheet.status_note" class="notes"><strong>Notes: </strong>{{ sheet.status_note }}</p>

        <div class="timesheet-entry-container" v-if="sheet.entries.length" v-for="entryDate in sheet.valid_entry_dates">
            <h3>{{ entryDate | human }}</h3>
            <div class="timesheet-entries">
                <dl class="timesheet-entry" v-for="(entry,index) in sheet.getEntriesByDate(entryDate)">
                    <dt>Hours</dt>
                    <dd>{{ entry.hours }}</dd>
                    <dt>Night Or Day?</dt>
                    <dd v-if="entry.night">Night</dd>
                    <dd v-else>Day</dd>
                    <dt v-if="entry.package">Related To</dt>
                    <dd v-if="entry.package">{{ entry.package.label }}</dd>
                    <dt v-if="entry.comments">Comments</dt>
                    <dd v-if="entry.comments">{{ entry.comments }}</dd>
                </dl>
            </div>
            <hr />
        </div>

    </div>
</template>

<script>
    export default {
        props: ['sheet'],
        data() {
            return {};
        },
        filters:{
            human: function (dateString) {
                var theDate = new Date(dateString);
                var weekdays = [];

                weekdays[0] = "Sunday";
                weekdays[1] = "Monday";
                weekdays[2] = "Tuesday";
                weekdays[3] = "Wednesday";
                weekdays[4] = "Thursday";
                weekdays[5] = "Friday";
                weekdays[6] = "Saturday";


                return weekdays[theDate.getDay()] + ' ' + hdate.prettyPrint(dateString);
            }
        },
        computed: {},
        methods: {},
        mounted() {

        }
    }
</script>

<style lang="scss" scoped>
    @import '../../sass/setup';

    dl.timesheet-entry {
        border-radius: $standardBorderRadius;
        padding: 1em;
        background-color: #ecf0f1;
        margin-bottom: 1em;
    }

    .timesheet-entry-container {
        @include clearfix();
        @include grid-collapse();
        h3 {
            @include grid-column(2);
        }
        .timesheet-entries {
            @include grid-column(6);
            min-width: 555px;
            max-width: calc(50% - 30px);
        }
        hr{
            clear:both;
            margin:1em 0;
        }

        @include mobile() {
            h3 {
                @include grid-column(12);
            }
            .timesheet-entries {
                @include grid-column(12);
                max-width: none;
                min-width: 0;
            }
        }
    }

    .approved,.disputed,.notes {
        padding: 1em;
        border-radius: $standardBorderRadius;
        background-color: $brand;
        color: #FFF;
        font-size: 14px;
        margin-bottom: 1em;
        &.approved{
            background-color:$green;
        }
        &.disputed{
            background-color:$red;
        }
        @include mobile() {
            text-align: center;
        }
        strong {
            display: block;
            font-size: 18px;
            margin-bottom: 7px;
            @include mobile() {
                text-align: center;
            }
        }
    }
</style>
